module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/link-gray-043f201f5414e4c31f5f27db39dc0ebb.svg";